import { FC } from 'react'
import { useField, useFormikContext } from 'formik'

import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import { Typography } from '@mui/material'
import FormLabel from '@mui/material/FormLabel'

interface IProps {
  fieldProps: {
    name: string
    label?: string
    required?: boolean
  }
  options: {
    label: string
    value: string | number
  }[]
  valueSelector?: string
  disabled?: boolean
  onChange?: any
  row?: boolean
}

const RadioField: FC<IProps> = ({ fieldProps, valueSelector, options, onChange, disabled, row }) => {
  const [field, meta] = useField(fieldProps.name)
  const { setFieldValue } = useFormikContext() // Manually set field value in Formik state
  const { error } = meta

  let value = valueSelector ? field.value[valueSelector] : field.value

  return (
    <FormControl>
      {fieldProps?.label && <FormLabel id='radio-buttons-group'>{fieldProps.label}</FormLabel>}
      <RadioGroup
        value={value} // Handles selected option
        onChange={(event, newValue) => {

          if (valueSelector) {
            newValue = {
              ...field.value,
              [valueSelector]: newValue,
            }
          }

          if (newValue) setFieldValue(field.name, newValue) // Set selected value in formik state
          if (onChange) onChange(newValue) // If extra action is needed on change
        }}
        row={row}
        aria-labelledby='radio-buttons-group'
        id={fieldProps.name}
        name={fieldProps.name}
        sx={{ position: 'relative' }}
      >
        {options.map((option, i) => (
          <FormControlLabel
            value={option.value}
            control={<Radio />}
            label={option.label}
            disabled={disabled}
            key={i}
          />
        ))}
        {fieldProps.required && (
          <Typography
            color='error'
            aria-hidden='true'
            style={{ position: 'absolute', top: -4, left: 15 }}
            className='MuiInputLabel-asterisk MuiFormLabel-asterisk css-14lvn6g-MuiFormLabel-asterisk'
          >
            *
          </Typography>
        )}
      </RadioGroup>
      {
        <FormHelperText style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', margin: 0 }}>
          {error}
        </FormHelperText>
      }
    </FormControl>
  )
}

export default RadioField
